import { setSignature, resetSignature } from './set-signature';

export const actions = {
	setSignature,
	resetSignature,
} as const;

export type Actions = typeof actions;
